var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neutral_9_",
    className: "st3",
    d: "M343.2,294.4c28.5-31.9,64-71.7,64-119.6c0-77.7-70.5-140.9-157.1-140.9 c-86.7,0-157.2,63.2-157.2,140.9c0,47,35.4,86.8,63.9,118.9c18.1,20.3,35.1,39.5,35.1,52.3v11.9c-3.8,0.1-7.8,0.1-11.8,0.2 c-4.8,0.1-8.6,3.9-8.6,8.6v43.2c0,11.9,9.8,21.6,21.8,21.6h16.5c2.8,19.5,19.8,34.6,40.3,34.6c20.5,0,37.4-15.1,40.3-34.6h16.5 c12,0,21.8-9.7,21.8-21.6c0.6-42.7,0.1-44.3-0.4-45.9c-1.3-3.9-1.9-5.9-19.8-6.7v-11.3C308.4,333.4,325.3,314.4,343.2,294.4z  M250,448.8c-10.8,0-19.9-7.4-22.5-17.3h44.9C269.9,441.4,260.8,448.8,250,448.8z M311.4,374.7c0,8.2-0.1,22.2-0.3,35v0.1 c0,2.4-2,4.4-4.3,4.4H193.2c-2.4,0-4.3-2-4.3-4.4v-34.7C231.5,374.7,291.1,374.2,311.4,374.7z M259,270.4 c-1.1,34.5-9.2,66.7-24.5,86.9c-7.7,0.1-16.1,0.2-25.1,0.3v-11.7c0-19.3-18.3-39.9-39.5-63.7c-27.9-31.4-59.5-67-59.5-107.4 c0-68.2,62.7-123.6,139.7-123.6c77,0,139.7,55.4,139.7,123.6c0,41.4-31.7,76.8-59.6,108.1c-21,23.5-39.2,43.9-39.2,63.2V357 c-9.2-0.1-20.8,0-35.5,0.1c13.4-23.5,20.4-55.8,21.1-89.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "COLOR_1_",
    className: "st2",
    d: "M331.8,193.7c-7.4-27.8-32.2-78.2-115.3-103.8c-2.6-0.8-5.4-0.4-7.6,1.2c-2.2,1.5-3.6,4-3.7,6.7 c-0.6,12.2-6.9,25-14.2,39.9c-11.8,24.1-26.6,54.1-20.9,94.1c4.7,32.8,30.3,46.4,52.7,48.2c12.3,1,23.9-1.1,32.9-5.4l17.5-3 c2.1,0.6,4.4,1.1,6.7,1.3c15.6,1.7,33.1-4.9,44.4-16.9C335.6,244.1,338.6,219.1,331.8,193.7z M311.7,244.2 c-7.4,7.9-19.6,12.7-29.7,11.5c-2.4-0.3-6.4-1.1-8.9-3.6c-1.9-37.2-11.2-74.8-28-103.8c-2.4-4.1-7.7-5.6-11.9-3.2 c-4.2,2.4-5.6,7.6-3.2,11.8c15.4,26.7,24,61.8,25.7,96.5c-2.8,5-15.4,10.8-31.3,9.4c-9.8-0.8-32.9-5.7-36.9-33.4 c-5-34.8,7.9-61,19.3-84.2c6-12.1,11.7-23.7,14.3-35.6c67.2,23.9,87.7,65.3,93.9,88.5C321,221,316.7,238.8,311.7,244.2z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechGreen;